import { Type } from "@themes/pollinator/ui/Type";

export type Props = {
  /** Error message to display */
  message: string;
};

/**
 * Error state display for missing or invalid step data.
 * Shows an error message.
 */
export function ErrorState({ message }: Props) {
  return (
    <div
      className="w-full flex flex-col items-center justify-center p-6 gap-4"
      data-testid="step-error-state"
    >
      <Type variant="body2" className="text-brand-700">
        {message}
      </Type>
    </div>
  );
}

export default ErrorState;
